import {Button} from 'primereact/button'
import {forwardRef} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {upperCase} from '../../utils/CommonUtils'

const FormHeader = forwardRef(
    ({header = '', onHide = () => {}, hideMargin}, ref) => {
        const {translateDatatable} = TranslateUtils()
        return !!header ? (
            <div
                className={`custom-form-header flex justify-content-between align-items-center ${
                    !hideMargin && 'mt-5'
                } `}>
                <div></div>
                <div>
                    <h5
                        className="mb-0 text-center font-bold"
                        style={{color: 'white'}}>
                        <strong>{upperCase(header)}</strong>
                    </h5>
                </div>

                <Button
                    icon="pi pi-arrow-left"
                    label={translateDatatable('Back')}
                    onClick={() => onHide()}
                    className="mr-3 px-3"
                />
            </div>
        ) : null
    },
)

export default FormHeader
